import { createApp } from 'vue'
import options from './DonationAmount.options'

const el = '.kb-component--donation-amount'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DonationAmountDOM) => {
            const template = DonationAmountDOM.outerHTML
            options.template = template
            const showCustomDonation = DonationAmountDOM.hasAttribute(
                'show-custom-Donation'
            )
            const component = createApp(options, { showCustomDonation }).use(
                Store
            )
            component.mount(DonationAmountDOM)
        })
    }
}
